import { render } from "./UmedidaForm.vue?vue&type=template&id=3bacb924&scoped=true"
import script from "./UmedidaForm.vue?vue&type=script&lang=js"
export * from "./UmedidaForm.vue?vue&type=script&lang=js"

import "./UmedidaForm.vue?vue&type=style&index=0&id=3bacb924&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bacb924"]])

export default __exports__